import { render } from "./ProductCloudSidebar.vue?vue&type=template&id=7f2a355e&scoped=true&ts=true"
import script from "./ProductCloudSidebar.vue?vue&type=script&lang=ts"
export * from "./ProductCloudSidebar.vue?vue&type=script&lang=ts"

import "./ProductCloudSidebar.vue?vue&type=style&index=0&id=7f2a355e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f2a355e"]])

export default __exports__